module.exports = __webpack_public_path__ + "front/img/edm-banner-xianxia-bj.ff0f9af2.png";